exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".due-to-others-modal .container .jq-checkbox{display:inline-block;width:15px;height:15px;background:#fff;border-radius:2px;border:1px solid #979797}.due-to-others-modal .container .jq-checkbox.checked{background:#3ec19d;border:1px solid #3ec19d}.due-to-others-modal .container .jq-checkbox.checked:after{content:\"\";width:5px;height:12px;color:#fff;display:block;position:absolute;top:0;left:4px;border:2px solid #fff;border-left:none!important;border-top:none!important;transform:rotate(35deg)}@media (min-width:768px){.due-to-others-modal .modal-dialog{overflow:auto;width:537px;height:100%}}@media (max-width:768px){.due-to-others-modal .modal-dialog{position:absolute;width:100vw;height:100vh;margin:0}.due-to-others-modal .modal-dialog .modal-content{border:none;box-shadow:none}.due-to-others-modal .modal-dialog .modal-content a.accept-close-popup,.due-to-others-modal .modal-dialog .modal-content input.accept-send-mail{font-size:16px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/acceptRejectApplication/rejectApplication/dueToOthersModal/dueToOthersModal.css
// module id = 500
// module chunks = 0